function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "product_illustration",
  transform: "translate(-935.089 -158.687)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4129",
  "data-name": "Group 4129",
  transform: "translate(494.606 -30.868)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5195",
  "data-name": "Path 5195",
  d: "M674.926,453.818l25.225,62.741,6.156,86.576-59.084,6.487s1.586-50.839,0-61.247L634.5,578.111l-60.228,17.246-12.14-61.845,24.554.293,39.622-77.52s13.051-5.742,26.779-5.742A77.23,77.23,0,0,1,674.926,453.818Z",
  transform: "translate(-72.955 -157.062)",
  fill: "#ce1212",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_84",
  "data-name": "Line 84",
  y1: 38.603,
  x2: 14.576,
  transform: "translate(573.766 354.145)",
  fill: "#231f20",
  stroke: "#1b1717",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5196",
  "data-name": "Path 5196",
  d: "M769.752,841.388l66.8-7.335-2.577,20.22-64.228,3.766Z",
  transform: "translate(-198.26 -388.524)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5197",
  "data-name": "Path 5197",
  d: "M821.249,887.651l.709,8.188L851,906.94l-71.86,6.145-1.388-22.7Z",
  transform: "translate(-203.088 -420.871)",
  fill: "#fff",
  stroke: "#231f20",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5198",
  "data-name": "Path 5198",
  d: "M517.378,652.679l17.395,1.041L548.6,724.588l-28.546-12.142Z",
  transform: "translate(-45.944 -279.058)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5199",
  "data-name": "Path 5199",
  d: "M471.521,654.3s-24.123-4.571-30.268-.408c.991,16.652,3.766,79.888,3.766,79.888l10.8-23.59,17.818-8.528Z",
  transform: "translate(0 -278.733)",
  fill: "#fff",
  stroke: "#231f20",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5200",
  "data-name": "Path 5200",
  d: "M767.413,306.517l-8.945-18.337c-4.609,3.345-26.762,18.956-38.953,19.4-9.063.331-30.107-15.437-30.107-15.437a4.384,4.384,0,0,1-3.37,1.834,6.431,6.431,0,0,1-3.073-1.338s-44.107,18.659-58.9,40.365c4.361,15.859,32.374,47.687,34.753,50.14,2.453-1.338,12.229-16.54,12.229-16.54s-18.436-23.565-19.179-26.762,11.225-13.306,11.225-13.306l1.327,31.45s12.126-5.21,24.1-5.432a89.457,89.457,0,0,1,23.788,3.271s-1.716-26.713.537-26.525c14.472,1.211,54.572-22.785,54.572-22.785",
  transform: "translate(-110.333 -59.071)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5201",
  "data-name": "Path 5201",
  d: "M973.587,267.142s11.2-12.987,14.034-10.355c3.351,3.118-6.083,11.713-6.083,11.713s10.49-6.39,11.832-4.485c2.53,3.593-9.416,10.407-9.416,10.407s10.667-3.172,11.894-.607c1.415,2.959-12.687,7.843-12.687,7.843s4.733.351,4.956,1.536c.632,3.37-16.106,4.163-16.106,4.163l-8.945-18.337s6.17-10.816,8.7-10.667.471,3.283.855,5.018c.146.657,1.335,4.5,1.189,5.352a23.246,23.246,0,0,1-1.449,3.94",
  transform: "translate(-314.93 -39.912)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5202",
  "data-name": "Path 5202",
  d: "M721.088,498.648a17.672,17.672,0,0,1,1.846,4.621c.2,1.685-8.722,18.733-8.722,18.733l-2.49-11.832Z",
  transform: "translate(-163.236 -186.095)",
  fill: "#fff",
  stroke: "#231f20",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5203",
  "data-name": "Path 5203",
  d: "M755.575,229.663s-.259-6.854,1.45-9.123c2.156-2.862,4.71-3.377,5.9-5.086s2.538-3.847,5.4-3.2c5.5,1.239,6.653,16.737,6.653,16.737s-.7.747-8.957,1.178C757.507,230.611,755.575,229.663,755.575,229.663Z",
  transform: "translate(-189.695 -13.174)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_651",
  "data-name": "Ellipse 651",
  cx: 2.881,
  cy: 1.666,
  rx: 2.881,
  ry: 1.666,
  transform: "translate(574.354 195.626)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5204",
  "data-name": "Path 5204",
  d: "M759.227,257.4c3.329.107,11.157,2.529,13.784-.791s-1.834-7.483-3.42-9.812.05-9.862-12.34-8.128-11.844,12.129-11.881,13.5-2.642,3.081-1.524,5.091C745.326,259.929,755.266,257.275,759.227,257.4Z",
  transform: "translate(-182.457 -29.035)",
  fill: "#111411",
  stroke: "#000",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5205",
  "data-name": "Path 5205",
  d: "M766.528,278.165s.262.779,2.439,1.034c.955.112,2.753-1.172,2.753-1.172l-.189-5.409s5.278-3.048,4.312-7.991c0,0-4.572-.539-5.78-.911s-2.992,3.265-4.4,2.967-3.221-1.71-3.717-1.065,1.437,2.6,1.437,2.6a4.906,4.906,0,0,0,3.42,4.237C766.872,273.97,766.528,278.165,766.528,278.165Z",
  transform: "translate(-193.497 -44.291)",
  fill: "#fff",
  stroke: "#231f20",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5206",
  "data-name": "Path 5206",
  d: "M877.029,444.81l-6.839,40.1,45.643-8.028-8.541-35.831Z",
  transform: "translate(-258.877 -151.335)",
  fill: "#ce1212",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5207",
  "data-name": "Path 5207",
  d: "M878.315,377.975s-14.426-32.032,1.482-47.66",
  transform: "translate(-260.164 -84.501)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5208",
  "data-name": "Path 5208",
  d: "M930.417,364.718s3.354,2.265,4.568,4.634",
  transform: "translate(-295.227 -105.264)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5209",
  "data-name": "Path 5209",
  d: "M965.575,348.367l-19.823,23.621L969.933,390.8l22.205-22.337Z",
  transform: "translate(-304.482 -95.396)",
  fill: "#ce1212",
  stroke: "#231f20",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5210",
  "data-name": "Path 5210",
  d: "M927.451,373.544s-1.948-5.24-1.948-6.793",
  transform: "translate(-292.261 -106.491)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5211",
  "data-name": "Path 5211",
  d: "M916,308.835c5.253-11.588,15.165-.66,31.618,12.721",
  transform: "translate(-286.527 -68.584)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5212",
  "data-name": "Path 5212",
  d: "M897.627,379.379l12.043,38.209,43.116-25.275L923.727,362.43Z",
  transform: "translate(-275.437 -103.883)",
  fill: "#dadada",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5213",
  "data-name": "Path 5213",
  d: "M901.434,316.292c-14.422-.655-6.839,35.236-6.839,35.236",
  transform: "translate(-272.404 -76.032)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5214",
  "data-name": "Path 5214",
  d: "M952.707,353.354a44.257,44.257,0,0,1,4.262,3.6",
  transform: "translate(-308.679 -98.406)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5215",
  "data-name": "Path 5215",
  d: "M531.019,463.56l38.748-16.63,16.8,24.184L552.967,501Z",
  transform: "translate(-54.176 -154.881)",
  fill: "#ce1212",
  stroke: "#000",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_85",
  "data-name": "Line 85",
  y1: 4.659,
  x2: 4.628,
  transform: "translate(515.59 287.39)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5216",
  "data-name": "Path 5216",
  d: "M681.211,423.3c11.619,5.009-10.084,33.555-10.084,33.555",
  transform: "translate(-138.737 -140.617)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_86",
  "data-name": "Line 86",
  y1: 2.177,
  x2: 4.142,
  transform: "translate(510.734 277.234)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5217",
  "data-name": "Path 5217",
  d: "M648.319,415.054s1.922,8.857-7.335,15.76a52.92,52.92,0,0,1-24.482,9.515",
  transform: "translate(-105.769 -135.643)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5218",
  "data-name": "Path 5218",
  d: "M562.706,405.247l-33.6-6.443-1.743,35.979,35.34-4.262Z",
  transform: "translate(-51.972 -125.836)",
  fill: "#dadada",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_87",
  "data-name": "Line 87",
  x2: 60.461,
  transform: "translate(487.045 492.214)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_88",
  "data-name": "Line 88",
  y1: 2.379,
  x2: 36.822,
  transform: "translate(465.834 499.053)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_652",
  "data-name": "Ellipse 652",
  cx: 12.266,
  cy: 12.266,
  r: 12.266,
  transform: "translate(477.678 190.305)",
  fill: "#ce1212",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5219",
  "data-name": "Path 5219",
  d: "M584.662,243.895l-9.61,5.162-9.61,5.162.335-10.9.335-10.9,9.276,5.742Z",
  transform: "translate(-74.952 -25.412)",
  fill: "#fff",
  stroke: "#231f20",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5220",
  "data-name": "Path 5220",
  d: "M1036.673,686.507l8.948-3.977s-2.585,10.538,1.392,13.52c3.723,2.793,14.614-1.093,18.093,3.181,2.984,3.665.994,20.679.994,20.679l-6.363,3.38s2.083-14.013-1.591-17.1c-4.971-4.176-13.114.879-16.5-1.392C1036.673,701.468,1036.673,686.507,1036.673,686.507Z",
  transform: "translate(-359.356 -297.074)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})));

function SvgProductIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 267.794,
    height: 312.674,
    viewBox: "0 0 267.794 312.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIllustration);
export default __webpack_public_path__ + "static/media/product-illustration.fbd70840.svg";
export { ForwardRef as ReactComponent };